import React from 'react';
import AuthCallback from '../../components/user/AuthCallback';

const AuthCallbackPage = (props) => (
  <AuthCallback {...props} />
);

export default AuthCallbackPage;